const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '\u20AC',
  GBP: '\u00A3',
};

const SYMBOL_TO_CODE = {
  '$': 'USD',
  '\u20AC': 'EUR',
  '\u00A3': 'GBP',
};

export function normalizeCurrencyCode(value, fallback = 'EUR') {
  if (typeof value !== 'string') {
    return fallback;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return fallback;
  }

  if (SYMBOL_TO_CODE[trimmed]) {
    return SYMBOL_TO_CODE[trimmed];
  }

  const upper = trimmed.toUpperCase();
  if (upper === 'US$') {
    return 'USD';
  }
  if (upper === 'EURO') {
    return 'EUR';
  }
  if (upper === 'POUND' || upper === 'POUNDS') {
    return 'GBP';
  }

  if (/^[A-Z]{3}$/.test(upper)) {
    return upper;
  }

  return fallback;
}

export function resolveCurrencySymbol(code) {
  const normalized = normalizeCurrencyCode(code);
  return CURRENCY_SYMBOLS[normalized] || normalized;
}

export function formatCurrencyAmount(
  value,
  currency,
  {
    locale = 'en-US',
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    euroSymbolAfter = true,
  } = {}
) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return null;
  }

  const currencyCode = normalizeCurrencyCode(currency);

  try {
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits,
      maximumFractionDigits,
    });

    if (euroSymbolAfter && currencyCode === 'EUR') {
      const parts = formatter.formatToParts(numeric);
      const symbol = parts.find((part) => part.type === 'currency')?.value || resolveCurrencySymbol(currencyCode);
      const amountPart = parts
        .filter((part) => part.type !== 'currency')
        .map((part) => part.value)
        .join('')
        .trim();
      return `${amountPart} ${symbol}`;
    }

    return formatter.format(numeric);
  }
  catch (_error) {
    const symbol = resolveCurrencySymbol(currencyCode);
    const amountPart = numeric.toFixed(maximumFractionDigits);
    if (currencyCode === 'EUR' && euroSymbolAfter) {
      return `${amountPart} ${symbol}`;
    }
    return `${symbol}${amountPart}`;
  }
}
